import { Container } from 'aurelia-dependency-injection';
import { AureliaConfiguration } from 'aurelia-configuration';

export const loadThemeStyles = async ({ website }) => {
    try {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', 'Basic c2lvOnNpbw==');

        const isDev =
            Container.instance.get(AureliaConfiguration).get('apiUrl') ===
            'https://127.0.0.1:8000/api/v2/';

        const url = isDev
            ? `http://localhost:3000/api/styles`
            : `${website.url}/api/styles`;
        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const parsedStyles = await response.json();
        return parsedStyles?.styles?.css || '';
    } catch (error) {
        return '';
    }
};
